import styled from 'styled-components';
import {ProductType} from '@/enums';
import {SimpleListBox, SimpleListBoxTitle} from '@/styled-components';
import {palette} from '@/styles';
import {Typography} from '../Typography';
import {Link} from 'react-router-dom';
import {paths} from '@/router';

interface IProps {
  isTrial: boolean;
  productType?: ProductType;
}

const ONE_DAY_LIMIT_NOTES = [
  '1일 요금제는 신규 회원의 서비스 체험을 위해 제공되는 특가 상품으로, 계정당 최소 1회에 한하여 구매가 가능합니다.',
  '이미 1일 요금제를 구매하신 이력이 있는 회원은 해당 요금제의 재구매가 불가능하며, 정기 결제 또는 기타 단건 요금제를 이용해 주셔야 합니다.',
];

const NOTE = {
  [ProductType.OneTime]: [
    {
      title: '이용 규정',
      desc: [
        `할인가가 적용된 요금제는 프로모션 상품입니다`,
        '프로모션 상품은 기간 한정 판매 상품으로 추후 회사가 정한 일자에 판매 종료될 수 있습니다.<br />(상품 판매 종료 시점에 이용자에게 미리 공지 예정)',
        '단건 결제 요금제 (ex. 7일 이용권)는 일반적인 상품 결제와 같이 한 번의 결제로 지불이 완료되는 상품입니다.<br />(정기적으로 매월 정기 결제일에 자동 결제가 발생하는 정기 결제 상품과 다릅니다.)',
        '이용 기간이 만료되면 추가로 결제가 진행되지 않습니다.',
        '정상가로 결제되는 금액은 VAT 포함 금액입니다.',
        '현재 이용 중인 결제 상품이 있는 경우 다른 결제 상품과 동시에 이용할 수 없습니다.',
        '이용 기간 중에는 결제 상품 변경이 불가능하지만, 환불 가능 기간 내에 환불 조건을 충족하면 변경이 가능합니다.<br />(ex. 7일 이용권 → 월간 이용권)',
      ],
    },
    {
      title: '환불 규정',
      desc: [
        '구매 시점으로부터 24시간 이내 서비스 이용 이력이 없으면 환불이 가능합니다.<br />(즉, 이용 이력이 발생하면 환불이 어렵습니다.)',
        '부분 환불은 지원하지 않습니다.',
        `환불은 고객센터를 통해 접수 부탁드립니다.`,
      ],
    },
  ],
  [ProductType.Subscription]: [
    {
      title: '이용 규정',
      desc: [
        '할인가가 적용된 요금제는 프로모션 상품입니다',
        '프로모션 상품은 기간 한정 판매 상품으로 추후 회사가 정한 일자에 판매 종료될 수 있습니다.<br />(상품 판매 종료 시점에 이용자에게 미리 공지 예정)',
        `'월간 이용권' 요금제는 매월 월 단위로 결제되는 정기 결제 상품입니다.`,
        '정기 결제일은 상품을 결제한 일자로 자동 설정되며 매월 정기 결제일에 등록한 결제 수단으로 자동 결제됩니다.',
        '만약 29일, 30일, 31일이 다음 정기 결제일인 경우 당월에 해당 일자가 없다면 마지막 날에 결제됩니다.<br />(ex. 3월 1일 선택한 요금제로 첫 결제 후 매월 1일 결제)',
        '정상가로 결제되는 금액은 VAT 포함 금액입니다.',
        '현재 이용 중인 결제 상품이 있는 경우 다른 결제 상품과 동시에 이용할 수 없습니다.',
        '이용 기간 중에는 결제 상품 변경이 불가능하지만, 환불 가능 기간 내에 환불 조건을 충족하면 변경이 가능합니다.<br />(ex. 월간 이용권 → 7일 이용권)',
      ],
    },
    {
      title: '결제 수단 변경 규정',
      desc: [
        '결제 수단은 언제든지 변경할 수 있으며, 변경 시 다음 정기 결제일부터 적용됩니다.',
      ],
    },
    {
      title: '해지 규정',
      desc: [
        '다음 달 정기 결제 중단을 희망하시는 경우 이용 기간 만료 1일 전까지 구독 해지를 신청하셔야 합니다.',
        '구독을 해지하더라도 남은 이용 기간 마지막 날까지 이용이 가능하며 이후 해지 처리됩니다.',
        '다음 정기 결제일에 자동 결제 실패 시 일시정지 상태로 전환되며, 1일 이내 결제 미복구 시 구독 해지됩니다.',
      ],
    },
    {
      title: '환불 규정',
      desc: [
        '구매 시점으로부터 24시간 이내 서비스 이용 이력이 없으면 환불이 가능합니다.<br />(즉, 이용 이력이 발생하면 환불이 어렵습니다.)',
        '부분 환불은 지원하지 않습니다.',
        `환불은 고객센터를 통해 접수 부탁드립니다.`,
      ],
    },
  ],
  trial: [
    {
      title: '무료 체험 규정',
      desc: [
        '결제 예정일에 등록한 결제 수단으로 요금이 자동 결제됩니다.',
        '구독 시작을 원하지 않으신다면 결제 예정일 전에 해지해 주셔야 합니다.',
        '무료 체험 기간에 구독을 해지하셔도 남은 무료 체험 기간 마지막 날까지 이용이 가능합니다.',
      ],
    },
    {
      title: '이용 규정',
      desc: [
        `할인가가 적용된 월간 이용권 요금제(사전 신청 혜택)는 프로모션 상품입니다.`,
        '프로모션 상품은 기간 한정 판매 상품으로 추후 회사가 정한 일자에 판매 종료될 수 있습니다.<br />(상품 판매 종료 시점에 이용자에게 미리 공지 예정)',
        `'월간 이용권 (사전 신청 혜택)' 요금제는 매월 월 단위로 결제되는 정기 결제 상품입니다.`,
        '정기 결제일은 상품을 결제한 일자로 자동 설정되며 매월 정기 결제일에 등록한 결제 수단으로 자동 결제됩니다.',
        '만약 29일, 30일, 31일이 다음 정기 결제일인 경우 당월에 해당 일자가 없다면 마지막 날에 결제됩니다.<br />ex. 3월 1일 선택한 요금제로 첫 결제 후 매월 1일 결제',
        '정상가로 결제되는 금액은 VAT 포함 금액입니다.',
      ],
    },
    {
      title: '결제 수단 변경 규정',
      desc: [
        '결제 수단은 언제든지 변경할 수 있으며, 변경 시 다음 정기 결제일부터 적용됩니다.',
      ],
    },
    {
      title: '해지 규정',
      desc: [
        '다음 달 정기 결제 중단을 희망하시는 경우 이용 기간 만료 1일 전까지 구독 해지를 신청하셔야 합니다.',
        '구독을 해지하더라도 남은 이용 기간 마지막 날까지 이용이 가능하며 이후 해지 처리됩니다.',
        '구독이 만료되면 프로모션 상품은 다시 구독할 수 없습니다.',
        '다음 정기 결제일에 자동 결제 실패 시 일시정지 상태로 전환되며, 1일 이내 결제 미복구 시 구독 해지됩니다.',
      ],
    },
    {
      title: '환불 규정',
      desc: [
        '마이프차 지도 서비스는 정보 위주 상품이므로 환불이 불가합니다.<br />(즉, 프로필 정보를 제출하고 유료 서비스에 접속한 이력이 있다면 환불은 불가합니다.)',
        `단, 환불 요청은 '결제일 포함 7일 이내, 프로필 정보 제출 이력이 없을 때' 가능합니다.`,
      ],
    },
  ],
};

export const PricingNote = ({isTrial, productType}: IProps) => {
  const notes = NOTE[
    isTrial ? 'trial' : productType || ProductType.OneTime
  ].map((section) => {
    if (section.title === '이용 규정') {
      return {...section, desc: [...section.desc, ...ONE_DAY_LIMIT_NOTES]};
    }
    return section;
  });

  return (
    <ListBox>
      <SimpleListBoxTitle>
        *결제 전 안내 사항을 확인해주세요.
      </SimpleListBoxTitle>
      <ul>
        {notes.map((i, idx) => (
          <li key={idx}>
            <Typography fontWeight={600}>{i.title}</Typography>
            <ul>
              {i.desc.map((d, dIdx) => (
                <li
                  key={'desc-' + dIdx}
                  dangerouslySetInnerHTML={{__html: d}}
                />
              ))}
            </ul>
          </li>
        ))}
        <li>
          <Typography fontWeight={600}>탈퇴 규정</Typography>
          <ul>
            <li>
              회원 탈퇴는 [
              <Link to={paths.mypage_account}>
                <u>개인정보관리</u>
              </Link>
              ]를 통해 가능합니다.
            </li>
            <li>
              유료 요금제를 사용 중인 회원은 탈퇴가 불가합니다. 유료 사용기간
              만료 후 시도해 주세요.
            </li>
            <li>
              회원 탈퇴 시 해당 ID로 보관된 회원의 개인 정보 및 데이터가
              파기되므로 복구 불가능한 점 유의 부탁드립니다.
            </li>
          </ul>
        </li>
      </ul>
    </ListBox>
  );
};

const ListBox = styled(SimpleListBox)`
  line-height: 1.8;
  color: #73797e;
  font-weight: 400;
  ${SimpleListBoxTitle} {
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 600;
    color: ${palette.gray700};
  }
`;
